import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { AuthProvider, useAuth } from "@/context/AuthContext";
import { Toaster } from "sonner";
import Landing from "@/pages/Landing";
import Login from "@/pages/Login";
import CustomerDashboard from "@/pages/CustomerDashboard";
import Track from "@/pages/Track";
import PublicReplyPage from "@/pages/PublicReplyPage";
import AdminDashboard from "@/pages/AdminDashboard";
import OfficeStaffDashboard from "@/pages/OfficeStaffDashboard";
import BankStaffDashboard from "@/pages/BankStaffDashboard";
import PartnerRegisterPage from "@/pages/PartnerRegisterPage";
import PartnerDashboard from "@/pages/PartnerDashboard";
import WhatsAppFAB from "@/components/app/WhatsAppFAB";
import ImpersonationBanner from "@/components/app/ImpersonationBanner";
import MetaPixelTracker from "@/components/app/MetaPixelTracker";
import { captureUtm } from "@/lib/utm";
import "@/App.css";

captureUtm();

const Protected = ({ role, children }) => {
  const { user, loading } = useAuth();
  if (loading) return <div className="min-h-screen flex items-center justify-center text-slate-400">Loading...</div>;
  if (!user) return <Navigate to="/login" replace />;
  if (role && (Array.isArray(role) ? !role.includes(user.role) : user.role !== role)) return <Navigate to="/login" replace />;
  return children;
};

export default function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <Toaster position="top-right" theme="dark" richColors />
        <MetaPixelTracker />
        <ImpersonationBanner />
        <WhatsAppFAB />
        <Routes>
          <Route path="/" element={<Landing />} />
          <Route path="/login" element={<Login />} />
          <Route path="/track" element={<Track />} />
          <Route path="/reply/:poolId" element={<PublicReplyPage />} />
          <Route path="/customer/dashboard" element={<Protected role="customer"><CustomerDashboard /></Protected>} />
          <Route path="/admin/*" element={<Protected role="admin"><AdminDashboard /></Protected>} />
          <Route path="/staff/*" element={<Protected role="office_staff"><OfficeStaffDashboard /></Protected>} />
          <Route path="/bank/*" element={<Protected role="bank_staff"><BankStaffDashboard /></Protected>} />
          <Route path="/partner/register" element={<PartnerRegisterPage />} />
          <Route path="/partner/*" element={<Protected role="partner"><PartnerDashboard /></Protected>} />
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </BrowserRouter>
    </AuthProvider>
  );
}
